import { UserSettingDto } from '../dto/user-setting-dto';
import { ViewModelProperty, RBCheck, VmpFieldType, RBConvert } from '@lfw/roesberg';
import { UserGroupDto } from '../dto/user-group-dto';
import { UserGroup } from '../models/user-group';

export class SettingsFactory {
  static fromDTO(dtoList: UserSettingDto[]): ViewModelProperty[] {
    const list: ViewModelProperty[] = [];

    if (!RBCheck.isNullOrHasNoValues(dtoList)) {
      dtoList.forEach((dto) => {
        const item = new ViewModelProperty();
        item.fieldName = dto.key;
        item.initialValue = dto.defaultValue;
        item.readOnly = !dto.changeAllowed;
        item.value = dto.value;

        // default is character field
        item.fieldType = VmpFieldType.Character;
        if (dto.control == 'check') {
          // checkbox
          item.fieldType = VmpFieldType.Boolean;
          item.value = RBConvert.stringToBool(dto.value);
        } else if (dto.control == 'list') {
          // combobox
          if (dto.values != null) {
            item.fieldType = VmpFieldType.VirtualList;
            item.valueList = dto.values.split(',');
          }
        }
        list.push(item);
      });
    }
    return list;
  }

  static UserGroupsFromDTO(dtoList: UserGroupDto[]): UserGroup[] {
    const list: UserGroup[] = [];

    if (!RBCheck.isNullOrHasNoValues(dtoList)) {
      dtoList.forEach((dto) => {
        const item = new UserGroup();
        item.id = dto.id;
        item.name = dto.name;
        list.push(item);
      });
    }
    return list;
  }
}
